import { create } from "zustand";
import { WrapUpState, WrapUpActions } from "./types";
import { WrapUp } from "@/common/models/wrapUp";

export const useWrapUpStore = create<WrapUpState & WrapUpActions>((set) => ({
	wrapUp: null,
	update: (wrapUp: WrapUp | null) => set({ wrapUp: wrapUp }),
}));
